var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCushion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.681 65.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.333 6.228 21.333 12.489 33.15 6.228 21.333 6.228"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.333 14.158 21.333 51.878 33.407 45.478 45.571 51.903 45.571 14.152 33.509 20.793 21.333 14.158"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.432 45.446 46.726 34.972 46.726 52.246 52.448 52.246 52.432 45.446"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.506 19.622 44.939 13.327 33.418 7.244 21.945 13.324 33.506 19.622"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.355 13.773 46.726 13.773 46.726 31.426 52.372 21.025 52.355 13.773"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.571 12.503 45.571 6.228 33.688 6.228 45.571 12.503"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.025 15.056 5.025 51.209 14.348 60.037 20.178 60.037 20.178 53.231 13.342 53.231 13.323 45.404 6.666 33.186 13.264 21.033 13.244 12.788 20.178 12.788 20.178 6.228 14.348 6.228 5.025 15.056"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.726 6.228 46.726 12.788 53.508 12.788 53.528 21.082 60.34 33.116 53.586 45.173 53.606 53.231 46.726 53.231 46.726 60.037 52.407 60.037 61.729 51.209 61.729 15.056 52.407 6.228 46.726 6.228"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.419 21.041 20.178 31.215 20.178 13.773 14.401 13.773 14.419 21.041"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.494 52.246 20.178 52.246 20.178 35.004 14.477 45.18 14.494 52.246"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.571 60.037 45.571 53.536 33.765 60.037 45.571 60.037"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.333 60.037 33.225 60.037 21.333 53.555 21.333 60.037"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.407 46.637 21.938 52.716 33.494 59.015 44.924 52.72 33.407 46.637"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.939 44.042 53.581 42.897 59.059 33.118 53.533 23.356 52.945 22.316 52.378 23.359 47.034 33.201 52.426 43.1 52.939 44.042"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.849 22.299 13.269 23.367 7.938 33.185 13.317 43.058 13.844 44.025 14.472 42.904 19.963 33.101 14.424 23.315 13.849 22.299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.737,14.538,53.094,5.406l-.43-.163H14.091l-.43.163L4.018,14.538l-.148.329V51.4l.148.329,9.643,9.132.43.163H52.664l.43-.163,9.643-9.132.147-.329V14.867Zm-16.011-.765h5.629l.017,7.252-5.646,10.4Zm5.652,9.586.567-1.043.588,1.04,5.526,9.762L53.581,42.9l-.642,1.145-.513-.942-5.392-9.9ZM46.726,34.972l5.706,10.474.016,6.8H46.726ZM21.333,6.228H33.15L21.333,12.489ZM33.418,7.244l11.521,6.083-11.433,6.3-11.561-6.3Zm-13.24,45H14.494l-.017-7.066L20.178,35ZM14.472,42.9l-.628,1.121-.527-.967L7.938,33.185l5.331-9.818.58-1.068.575,1.016L19.963,33.1Zm5.706-11.689L14.419,21.041,14.4,13.773h5.777Zm0-18.427H13.244l.02,8.245-6.6,12.153L13.323,45.4l.019,7.827h6.836v6.806h-5.83L5.025,51.209V15.056l9.323-8.828h5.83Zm1.155,47.249V53.555l11.892,6.482Zm.605-7.321,11.469-6.079L44.924,52.72l-11.43,6.3Zm23.633,7.321H33.765l11.806-6.5Zm0-8.134L33.407,45.478l-12.074,6.4V14.158l12.176,6.635,12.062-6.641Zm0-39.4L33.688,6.228H45.571ZM61.729,51.209l-9.322,8.828H46.726V53.231h6.88l-.02-8.058L60.34,33.116,53.528,21.082l-.02-8.294H46.726V6.228h5.681l9.322,8.828Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCushion);
export default __webpack_public_path__ + "static/media/cushion.5d88edca73163e0694a6aca3647cdff5.svg";
export { ForwardRef as ReactComponent };